import L from "leaflet";
import "leaflet.fullscreen";
import "leaflet.markercluster";
import _ from "lodash";
import * as z from "../../../framework";

class MarkerOptions {
    latitude: number;
    longitude: number;
    draggable: boolean;
    popUpHTML?: string;
    className?: string;
    icon?: any;
}
class MarkerLayer {
    label: string;
    type?: string;
    name?: string;
    group?: any;
}

class MapOptions {
    id: string;
    fullscreen?: boolean;
    fullscreenOptions?: any;
    stickyDefaultName?: string;
    markerLayers?: MarkerLayer[];
    position?: [number, number];
    zoom?: number;
    customStickyDefaults?: boolean;
}
export default class Map {
    options: MapOptions;
    leafletMap: any;
    public newLayer: boolean;
    private overlays: any;
    private baseLayers: any;
    private loaded: boolean;
    private selectedOverlays: string[];
    private selectedTileLayerIndex: number;

    constructor(options: MapOptions) {
        var me = this;

        me.options = options;
        me.options.fullscreen = me.options.fullscreen === undefined ? true : me.options.fullscreen;
        me.options.fullscreenOptions = me.options.fullscreenOptions || {
            position: "topleft"
        };
        me.options.markerLayers = me.options.markerLayers || [];
        me.options.position = me.options.position || [
            z.user.companyData.Settings.Latitude,
            z.user.companyData.Settings.Longitude
        ];
        me.options.zoom = me.options.zoom || z.user.companyData.Settings.SchedulerZoom;
        me.leafletMap = L.map(me.options.id, {
            attributionControl: false,
            fullscreenControl: me.options.fullscreen,
            fullscreenControlOptions: me.options.fullscreenOptions
        });
        me.overlays = {};
        me.baseLayers = {};
        me.selectedOverlays = [];
        me.selectedTileLayerIndex = -1;
        me.newLayer = false;

        var optionValue = z.util.getOptionValue("TileLayers");
        var tileLayerDefinitions = $.parseJSON(optionValue);
        var tileLayers = [];

        if (me.options.stickyDefaultName) {
            me.leafletMap.on("overlayadd", (e) => {
                if (!_.includes(me.selectedOverlays, e.name)) {
                    me.selectedOverlays.push(e.name);
                }

                if (me.loaded) {
                    me.saveStickyDefaults();
                }
            });

            me.leafletMap.on("overlayremove", (e) => {
                _.remove(me.selectedOverlays, (label) => {
                    return label == e.name;
                });

                if (me.loaded) {
                    me.saveStickyDefaults();
                }
            });
        }

        _.each(tileLayerDefinitions, function (layerDefinition: any, index: number) {
            layerDefinition.name = layerDefinition.pane;
            delete layerDefinition.pane;
            layerDefinition.index = index;
            var tileLayer = L.tileLayer(layerDefinition.url, layerDefinition);
            tileLayers.push(tileLayer);
            if (me.options.stickyDefaultName) {
                tileLayer.on("add", (e) => {
                    me.selectedTileLayerIndex = index;

                    if (me.loaded) {
                        me.saveStickyDefaults();
                    }
                });
            }
        });

        _.each(tileLayers, function (tileLayer) {
            var label = z.ll(tileLayer.options.label);
            me.baseLayers[label] = tileLayer;
        });

        var stickyDefault = me.options.stickyDefaultName ?
            $.parseJSON(z.getLocalStorage(`StickyMap_${me.options.stickyDefaultName}`) || null) :
            undefined;

        if (!options.customStickyDefaults) {
            if (stickyDefault) {
                var tileLayerIndex = stickyDefault.tileLayerIndex;
                tileLayers[tileLayerIndex].addTo(me.leafletMap);
            } else {
                tileLayers[0].addTo(me.leafletMap);
            }
        }

        _.each(me.options.markerLayers, function (layer) {
            var markerLayer;

            if (layer.group) {
                markerLayer = layer.group;
            } else {
                markerLayer = me.createMarkerLayer(layer);
            }
            me.overlays[z.ll(layer.label)] = markerLayer;
            if (!options.customStickyDefaults) {
                if (stickyDefault) {
                    var selectedLayers = stickyDefault.selectedLayers;
                    if (_.includes(selectedLayers, z.ll(layer.label))) {
                        markerLayer.addTo(me.leafletMap);
                    }
                } else {
                    markerLayer.addTo(me.leafletMap);
                }
            }
        });

        L.control.layers(me.baseLayers, me.overlays).addTo(me.leafletMap);

        me.leafletMap.setView(me.options.position, me.options.zoom);

        var fullscreenButton = $(".leaflet-control-zoom-fullscreen");

        fullscreenButton.addClass("k-icon").addClass("k-i-fullscreen");

        me.leafletMap.on("enterFullscreen", () => {
            fullscreenButton.removeClass("k-i-fullscreen");
            fullscreenButton.addClass("k-i-full-screen-exit");
        });

        me.leafletMap.on("exitFullscreen", () => {
            fullscreenButton.removeClass("k-i-full-screen-exit");
            fullscreenButton.addClass("k-i-fullscreen");
            var button = $("#AddMapPinsButton");
            if (button && button.hasClass("map-button-fullscreen")) {
                button.removeClass("map-button-fullscreen");
            }
        });

        me.loaded = true;
    }

    showOrHideLoadingSpinner(action: string): void {
        var spinner = $(".map-pins-spinner"),
            button = $("#AddMapPinsButton"),
            fullscreenButton = $(".leaflet-control-zoom-fullscreen");

        switch (action){
            case "show":
                button.disable(true);
                spinner.show();
                if (!button.hasClass("map-pins-loading")) {
                    button.addClass("map-pins-loading");
                }
                if (fullscreenButton.hasClass("k-i-full-screen-exit") && !button.hasClass("map-button-fullscreen")) {
                    button.addClass("map-button-fullscreen");
                } else if (!fullscreenButton.hasClass("k-i-full-screen-exit") && button.hasClass("map-button-fullscreen")) {
                    button.removeClass("map-button-fullscreen");
                }
                break;
            case "hide":
            default:
                button.enable(true);
                spinner.hide();
                if (button.hasClass("map-pins-loading")) {
                    button.removeClass("map-pins-loading");
                }
        }
    }

    customMarker(args: any) {
        let html = `<div class='${args.classes} ${args.extraClass}'>
                        <i class="fas tech-badge"></i>
                    </div>`;

        if (args.length != undefined) {
            html = `<div class='${args.classes} ${args.extraClass}'>
                        <span class='cluster-badge badge'>${args.length}</span>
                        <i class="fas tech-badge"></i>
                    </div>`;
        }

        let options: L.divIcon = {
            html: html,
            className: args.className
        };

        if (!args.clusterGroup) {
            options.iconSize = [27, 36]; // size of the icon
            options.iconAnchor = [15, 38]; // point of the icon which will correspond to marker's location
            options.popupAnchor = [-2, -40]; // point from which the popup should open relative to the iconAnchor
        } else {
            options.iconSize = [27, 36]; // size of the icon
            options.iconAnchor = [5, -3]; // point of the icon which will correspond to marker's location
        }

        return L.divIcon(options);
    }

    createMarkerLayer(args: MarkerLayer) {
        var me = this;
        var classes = args.type ? args.type + "-marker map-marker" : "";

        return L.markerClusterGroup({
            name: args.name,
            maxClusterRadius: 40,
            chunkedLoading: true,
            iconCreateFunction: function (cluster) {
                var markers = cluster.getAllChildMarkers(),
                    extraClass = "",
                    noExtraClassFound = false;

                $.each(markers, function (index, marker) {
                    if (marker.extraClass == "red") {
                        extraClass = "red";
                        return false;
                    } else if (marker.extraClass == "gray") {
                        extraClass = "gray";
                    } else if (marker.extraClass == "not-in-filter") {
                        extraClass = "not-in-filter";
                    } else if (marker.extraClass == "") {
                        noExtraClassFound = true;
                    }
                });

                // blue > gray so remove the class
                if (noExtraClassFound && extraClass != "red") {
                    extraClass = "";
                }

                return me.customMarker({
                    classes: classes,
                    extraClass: extraClass,
                    length: cluster.getChildCount(),
                    className: "z-cluster-group",
                    clusterGroup: true
                });
            }
        });
    }

    addMarker(layerLabel: string, markerOptions: MarkerOptions) {
        var me = this;

        var marker = L.marker(
            [markerOptions.latitude, markerOptions.longitude],
            {
                icon: markerOptions.icon || me.customMarker({
                    className: markerOptions.className
                }),
                draggable: markerOptions.draggable
            }
        );

        if (markerOptions.popUpHTML) {
            marker.bindPopup(markerOptions.popUpHTML);
        }

        var layer = me.overlays[z.ll(layerLabel)];

        if (layer) {
            layer.addLayer(marker);
        }

        return marker;
    }

    createMarker(args) {
        var me = this;
        args = args || {};

        var marker = L.marker(
            [args.latitude, args.longitude],
            {
                icon: me.customMarker({
                    className: args.className,
                    extraClass: args.extraClass,
                    length: args.length
                }),
                draggable: args.draggable
            }
        );

        marker.classes = args.className;
        marker.type = args.type;
        marker.zData = args.zData;

        return marker;
    }

    getLayer(layerLabel: string) {
        return this.overlays[z.ll(layerLabel)];
    }

    moveEndEvent(cb: () => void) {
        var me = this;

        return me.leafletMap.on("moveend", function () {
            cb();
        });
    }

    addMapPinsButton(clickCB: (limited: boolean) => void) {
        var me = this;

        var MapButtons = L.Control.extend({
            onAdd: function (map) {
                var html = L.DomUtil.create("div");
                html.innerHTML = `
                    <button class="action-button add-map-pins map-pins-loading" id="AddMapPinsButton">
                        <span class="text-container">
                            <span class="text scheduler-map-pins-button">${z.ll("ShowAllMapPins")}</span>
                            <span class="message-loading map-pins-spinner"></span>
                        </span>
                    </button>
                `;
                return html;
            }
        });

        var mapButtons = new MapButtons({ position: "bottomleft" });
        me.leafletMap.addControl(mapButtons);

        var button = $("#AddMapPinsButton");
        button.click(function (e) {
            var text = $(".scheduler-map-pins-button"),
                limited: boolean,
                badge = $("#mapNotification");
            if (text.hasClass("map-pin-button-active")) {
                limited = true;
                text.text(z.ll("ShowAllMapPins"));
                text.removeClass("map-pin-button-active");
                if (badge.hasClass("hidden")) {
                    badge.removeClass("hidden");
                }
            } else {
                limited = false;
                text.text(z.ll("LimitMapPins"));
                text.addClass("map-pin-button-active");
                if (!badge.hasClass("hidden")) {
                    badge.addClass("hidden");
                }
            }

            clickCB(limited);
        });
    }

    addLegend(legendHTML: string) {
        var me = this;

        var MapLegend = L.Control.extend({
            onAdd: function (map) {
                var html = L.DomUtil.create("div");
                html.innerHTML = `<div id="legendContainer">${legendHTML}</div><nav class='menu-ui'><span id="mapNotification" class="map-notify badge hidden">'</span><a href='#' id='legendButton'><i class="fas fa-compass"></i></a></nav>`;
                return html;
            }
        });

        var mapLegend = new MapLegend({ position: "bottomright" });
        me.leafletMap.addControl(mapLegend);
        $("#legendContainer").hide();
    }

    saveStickyDefaults() {
        var me = this;

        var stickyDefault = {
            EntityName: `StickyMap_${me.options.stickyDefaultName}`,
            Field: me.options.stickyDefaultName,
            Value: JSON.stringify({
                tileLayerIndex: me.selectedTileLayerIndex,
                selectedLayers: me.selectedOverlays
            })
        };

        z.setLocalStorage(stickyDefault.EntityName, stickyDefault.Value);

        z.ajax({
            type: "PATCH",
            url: "StickyDefault/SetDefaults",
            data: { Defaults: [stickyDefault] }
        });

    }
}
